import { ScheduleOutlined, ShareAltOutlined } from "@ant-design/icons"
import { Button } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { ActionTooltip } from "../../../../components/ActionTooltip.tsx"

interface ReportShareScheduleActionsProps {
  canShare: boolean
  canSchedule: boolean
  /** Drop the button labels — the edit header has room for icons only. */
  iconOnly?: boolean
  onShare: () => void
  onSchedule: () => void
}

/**
 * The share and schedule pair, shared by the view page's toolbar and the edit
 * header so the two surfaces cannot drift on gating or copy.
 */
export const ReportShareScheduleActions = ({
  canShare,
  canSchedule,
  iconOnly = false,
  onShare,
  onSchedule
}: ReportShareScheduleActionsProps) => {
  const { t } = useTranslation()

  // A button that carries its label needs a tooltip only to explain a denial;
  // an icon-only button has none, so it needs the label in every state.
  const tooltip = (allowed: boolean, label: string, deniedKey: string) =>
    allowed ? (iconOnly ? label : undefined) : t(deniedKey)

  const scheduleLabel = t("reports.toolbar.schedule")
  const shareLabel = t("reports.toolbar.share")

  return (
    <>
      <ActionTooltip
        title={tooltip(canSchedule, scheduleLabel, "reports.toolbar.scheduleDenied")}
      >
        <Button
          icon={<ScheduleOutlined />}
          aria-label={scheduleLabel}
          disabled={!canSchedule}
          onClick={onSchedule}
        >
          {iconOnly ? undefined : scheduleLabel}
        </Button>
      </ActionTooltip>

      <ActionTooltip
        title={tooltip(canShare, shareLabel, "reports.toolbar.shareDenied")}
      >
        <Button
          icon={<ShareAltOutlined />}
          aria-label={shareLabel}
          disabled={!canShare}
          onClick={onShare}
        >
          {iconOnly ? undefined : shareLabel}
        </Button>
      </ActionTooltip>
    </>
  )
}
